import { useSelector } from 'react-redux';
import { RootState } from '../../../states/reducers';
import { UserTypeId } from '../../../helpers/constants';
import { InvestorLoanOffers } from './InvestorLoanOffers';
import { BorrowerLoanOffers } from './BorrowerLoanOffers';

export const LoanOffers = () => {
  const { auth } = useSelector((state: RootState) => state);
  const userTypeId = auth.authUser?.user.user_type_id;

  if (userTypeId === UserTypeId.INVESTOR) {
    return <InvestorLoanOffers />;
  } else if (userTypeId === UserTypeId.BORROWER) {
    return <BorrowerLoanOffers />;
  } else {
    return (
      <div>
        <div className='d-flex justify-content-center align-item-center'>
          <div className='text-center pt-20 pb-20'>
            <i className='bi bi-folder' style={{ fontSize: '3.5em' }}></i>
            <p className='text-muted ms-20p me-20p pt-3 pb-3'>There are no offers at the moment</p>
          </div>
        </div>
      </div>
    );
  }
};
